import Modal from '@mui/material/Modal'
import { Fragment, useState } from 'react'
import { PopupState } from 'material-ui-popup-state/hooks'
import ReassignExamLayout from '../exam/ReassignExamLayout'
import { useParams } from 'react-router-dom'
import UnavailableReassignementModal from './UnavailableReassignementModal'
import { useTimepointExamReassignementCheck } from '@features/qc_task_details_view/hooks/useTimepointExamReassignementCheck'
import { ContainerParam } from '@features/subject/subject.types'
import { useGetSubjectsList } from '@features/subject/hooks/useGetSubjectsList'

export default function ReassignExamModal({
  subject_pseudo_id,
  containers,
  popupState,
}: {
  subject_pseudo_id?: string
  containers?: ContainerParam[]
  popupState: PopupState
}) {
  const [modalOpen, setModalOpen] = useState(true)

  const handleClose = () => {
    sessionStorage.removeItem('reassign_exam_modal_state')
    setModalOpen(false)
    popupState.close()
  }

  const { studyId, subjectId, timepointSubmissionId } = useParams()

  const {
    data: subjectsData,
    error: subjectsError,
    isLoading: subjectsIsLoading,
  } = useGetSubjectsList(['SubjectsList', studyId!], {
    study_id: studyId!,
  })

  const { data, error, isLoading } = useTimepointExamReassignementCheck(
    ['TimepointExamReassignementCheck'],
    studyId,
    subjectId,
    timepointSubmissionId,
  )

  if (isLoading || subjectsIsLoading) {
    return (
      <Modal open={modalOpen} onClose={handleClose}>
        <div>Loading...</div>
      </Modal>
    )
  }

  if (error || subjectsError || !data || !data.data || !subjectsData || !subjectsData.data || !timepointSubmissionId) {
    return (
      <Modal open={modalOpen} onClose={handleClose}>
        <div>Error: {error?.message || subjectsError?.message}</div>
      </Modal>
    )
  }

  const isReassignable = data.data.timepoint_submission_ids.includes(timepointSubmissionId)

  return (
    <Fragment>
      {isReassignable ? (
        <Modal open={modalOpen} data-testid="reassign-modal">
          <ReassignExamLayout
            assignableTimepointSubmissions={data.data.timepoint_submission_ids}
            subjectPseudoId={subject_pseudo_id}
            timepointSubjects={subjectsData.data}
            handleClose={handleClose}
            containers={containers}
          />
        </Modal>
      ) : (
        <UnavailableReassignementModal open={modalOpen} onClose={handleClose} />
      )}
    </Fragment>
  )
}
